import { Box, Heading4, Helpers, Metrics, Text } from '@origin-digital/style-guide';

import React from 'react';

import { FormRowProps } from './FormRow.types';
import styled from 'styled-components';

const BoxWithResponsiveBottomMargin = styled(Box)`
  margin-bottom: ${Metrics.Spacing.M_Y}px;

  ${Helpers.media.LG`
    margin-bottom: ${Metrics.Spacing.M_Y_LG}px;
  `};
`;

const FormRow: React.StatelessComponent<FormRowProps> = ({
  ...props
}: FormRowProps): JSX.Element => {
  const { children, content, byline } = props;

  return (
    <React.Fragment>
      {!byline && content && content.heading && (
        <Box marginBottom={4}>
          <Heading4 text={content.heading} align="left" />
        </Box>
      )}
      {byline && content && content.heading && (
        <React.Fragment>
          <Heading4 text={content.heading} align="left" />
          <Box marginBottom={4} marginTop={2}>
            <Text size={'sm'}>{byline}</Text>
          </Box>
        </React.Fragment>
      )}
      <BoxWithResponsiveBottomMargin>{children}</BoxWithResponsiveBottomMargin>
    </React.Fragment>
  );
};

export { FormRow as default };
